import { Layout } from "layouts";
import { ContactDetails, ContactLocations, ContactMap, ContactForm, CareersButton } from "@/components/contact-us";

const ContactUs: React.FC = () => {
    return (
        <Layout page="contact">
            <ContactDetails />
            <ContactLocations />
            <CareersButton />
            <ContactForm />
            <ContactMap />
        </Layout>
    );
};

export default ContactUs;
